import Web3 from 'web3';
import { useToast } from "vue-toastification";
import Erc20ABI from "../wallet/abi/Erc20.json";
import Erc721ABI from "../wallet/abi/Erc721.json";
import Erc1155ABI from "../wallet/abi/Erc1155.json";
import ChainApi from '../wallet/ChainApi';

const toast = useToast();
const ethers = require('ethers');

export async function checkERC20Allowance(addr, tokenAddr, contractAddr) {
  const web3 = getWeb3();
  let result = false;
  if(isEqualZeroAddress(tokenAddr) ||
    tokenAddr == ethers.constants.AddressZero) {
    return true;
  }
  else {
    const tokenContract = new web3.eth.Contract(Erc20ABI, tokenAddr);
    await tokenContract.methods.allowance(addr, contractAddr).call().then(res => {
      if (res > 0) {
        result = true;
      }
    });
    return result;
  }
}

export async function approveERC20(addr, tokenAddr, contractAddr) {
  const web3 = getWeb3();
  let result = false;
  const tokenContract = new web3.eth.Contract(Erc20ABI, tokenAddr);
  await tokenContract.methods.approve(contractAddr, ethers.constants.MaxUint256).send({from: addr})
  .then(res => {
    result = true;
  })
  .catch(err => {
    toast.error(err.message, {timeout: 5000});
    console.log(err);
  });
  return result;
}

export async function checkERC721Allowance(addr, tokenAddr, contractAddr) {
  const web3 = getWeb3();
  let result = false;
  
  const tokenContract = new web3.eth.Contract(Erc721ABI, tokenAddr);
  await tokenContract.methods.isApprovedForAll(addr, contractAddr).call()
  .then(res => {
    console.log("checkERC721Allowance res:", res);
    result = res;
  })
  .catch(err => {
    toast.error(err.message, {timeout: 5000});
    console.log(err);
  });

  return result;
}

export async function approveERC721(addr, tokenAddr, contractAddr) {
  const web3 = getWeb3();
  let result = false;
  const tokenContract = new web3.eth.Contract(Erc721ABI, tokenAddr);
  await tokenContract.methods.setApprovalForAll(contractAddr, true).send({from: addr})
  .then(res => {
    console.log("approveERC721 res:", res);
    result = true;
  })
  .catch(err => {
    toast.error(err.message, {timeout: 5000});
    console.log(err);
  });
  return result;
}

export async function checkERC1155Allowance(addr, tokenAddr, contractAddr) {
  const web3 = getWeb3();
  let result = false;
  
  const tokenContract = new web3.eth.Contract(Erc1155ABI, tokenAddr);
  await tokenContract.methods.isApprovedForAll(addr, contractAddr).call()
  .then(res => {
    console.log("checkERC1155Allowance res:", res);
    
    result = res;
  })
  .catch(err => {
    toast.error(err.message, {timeout: 5000});
    console.log(err);
  });

  return result;
}

export async function approveERC1155(addr, tokenAddr, contractAddr) {
  const web3 = getWeb3();
  let result = false;
  const tokenContract = new web3.eth.Contract(Erc1155ABI, tokenAddr);
  await tokenContract.methods.setApprovalForAll(contractAddr, true).send({from: addr})
  .then(res => {
    console.log("approveERC1155 res:", res);
    result = true;
  })
  .catch(err => {
    toast.error(err.message, {timeout: 5000});
    console.log(err);
  });
  return result;
}

export async function getBalance(addr, tokenAddr) {
  const web3 = getWeb3();

  if(isEqualZeroAddress(tokenAddr)) {
    const chainApi = ChainApi;
    return await chainApi.chainWeb3.web3.eth.getBalance(addr);
  }

  const tokenContract = new web3.eth.Contract(Erc20ABI, tokenAddr);
  return await tokenContract.methods.balanceOf(addr).call({from: addr});
}



export function getProvider() {
  const chainApi = ChainApi;
  if(chainApi && chainApi.chainWeb3 && chainApi.chainWeb3.ethereum) {
    return chainApi.chainWeb3.ethereum;
  }
  else if(window.ethereum) {
    let tempEth = window.ethereum;
    if(window.ethereum.providers && window.ethereum.providers.length) {
      window.ethereum.providers.forEach(provider => {
          if(provider.isMetaMask) {
            tempEth = provider;
          }
      });
    }
    return tempEth;
  }
  else {
    let env = process.env.VUE_APP_ENV;
    if(env == 'dev') {
        return 'https://data-seed-prebsc-1-s1.binance.org:8545';
    }
    else {
      return 'https://bsc-dataseed.binance.org/';
    }
  }
}

export function getWeb3(provider = null) {
  const chainApi = ChainApi;
  if(provider) {
    return new Web3(provider);
  }
  else if(chainApi && chainApi.chainWeb3 && chainApi.chainWeb3.web3) {
    return chainApi.chainWeb3.web3;
  }
  else {
    let env = process.env.VUE_APP_ENV;
    if(env == 'dev') {
        return new Web3('https://data-seed-prebsc-1-s3.binance.org:8545');
    }
    else {
      return new Web3('https://bsc-dataseed.binance.org/');
    }
  }
}

export function isEqualZeroAddress(addr) {
  return addr == '0x0000000000000000000000000000000000000000' || addr == '0x0000000000000000000000000000000000000000000000000000000000000000';
}
